import React, { JSX } from 'react';
import { IconPix } from '@/assets/icons';
import { Button } from '@/components';
import phonePix from '@/assets/images/phonePix.png';

interface Props {
  qrCodeImage: string;
  qrCodeText: string;
  onCopyText: (text: string) => void;
}

export const PixPaymentContent: React.FC<Props> = ({
  qrCodeImage,
  qrCodeText,
  onCopyText,
}): JSX.Element => (
  <div className="font-dmsans relative px-4 sm:px-6 md:px-0">
    {/* Celular decorativo (só desktop) */}
    <img
      src={phonePix}
      alt="Pagamento Pix no celular"
      className="
        hidden lg:block
        absolute
        right-[-140px] top-1/2
        -translate-y-1/2
        w-[420px]
        rotate-[10deg]
        pointer-events-none select-none
      "
    />

    {/* Header */}
    <div className="flex items-center justify-center gap-3 mb-6 md:mb-8">
      <IconPix height="70px" className="text-alert-info-soft hidden md:block" />
      <IconPix height="48px" className="text-alert-info-soft md:hidden" />
      <h2 className="font-bold text-neutro-b-400 text-xl md:text-3xl">Pague via Pix</h2>
    </div>

    {/* Grid: mobile 1 coluna, desktop 2 colunas como está */}
    <div className="grid grid-cols-1 md:grid-cols-[320px_1fr] gap-6 md:gap-28 items-stretch">
      {/* QR */}
      <div className="flex justify-center md:justify-start items-center">
        <div
          className="
            border border-label bg-white rounded-md
            p-3 sm:p-4
            w-full max-w-[320px] aspect-square
            md:w-[400px] md:h-[400px] md:max-w-none
            flex items-center justify-center
            shrink-0
          "
        >
          <img src={qrCodeImage} alt="qrcode" className="w-full h-full object-contain" />
        </div>
      </div>

      {/* Texto */}
      <div className="text-center md:text-left">
        <h3 className="font-bold text-neutro-b-400 text-lg md:text-xl mb-2">
          Pague com PIX QR Code
        </h3>

        <p className="text-base font-normal text-neutro-w-600 mb-5 md:max-w-[520px]">
          Acesse o seu internet banking ou aplicativo de pagamento e escolha pagar via PIX Ler QR
          Code, em seguida aponte a sua câmera para finalizar o processo.
        </p>

        <div className="flex my-5 items-center justify-between md:max-w-[520px]">
          <hr className="block w-full h-px bg-label" />
          <span className="mx-3 text-neutro-b-400 font-dmsans font-bold">ou</span>
          <hr className="block w-full h-px bg-label" />
        </div>

        <h3 className="font-bold text-neutro-b-400 text-lg md:text-xl mb-2">
          Pague com PIX Copia e Cola
        </h3>

        <p className="text-base font-normal text-neutro-w-600 mb-3 md:max-w-[520px]">
          Copie e cole o código abaixo no seu banco/app de pagamento:
        </p>

        <div className="p-3 rounded-md bg-gray-50 border border-label mb-4 md:max-w-[520px]">
          <p className="text-xs font-normal text-neutro-b-600 break-all max-h-[96px] overflow-auto md:max-h-none">
            {qrCodeText}
          </p>
        </div>

        <Button
          type="button"
          title="Copiar código PIX"
          buttonStyle="primary"
          size="xlg"
          className="w-full md:max-w-[520px]"
          onClick={() => onCopyText(qrCodeText)}
        />
      </div>
    </div>
  </div>
);
